import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const ROLE_LABELS = {
  super_admin: 'Super Admin',
  operations: 'Operations',
  billing: 'Billing',
  marketing: 'Marketing',
  account_manager: 'Account Manager',
};

const ROLE_COLORS = {
  super_admin: '#e63946',
  operations: '#4FC3F7',
  billing: '#00C49F',
  marketing: '#f4a261',
  account_manager: '#a8dadc',
};

export default function EmployeeSidebar() {
  const { user, role } = useAuth();
  const isSuperAdmin = role === 'super_admin';
  const isOps = ['super_admin', 'operations'].includes(role);
  const isBilling = ['super_admin', 'billing'].includes(role);
  const isMarketing = ['super_admin', 'marketing', 'operations'].includes(role);

  const item = (to, icon, label) => (
    <NavLink to={to} className={({ isActive }) => `sidebar-item${isActive ? ' active' : ''}`}>
      <span>{icon}</span> {label}
    </NavLink>
  );

  return (
    <nav className="sidebar" aria-label="Employee navigation" style={{ width: 240 }}>
      {/* Employee badge */}
      <div style={{ padding: '12px 20px 8px', marginBottom: 4 }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,0.6)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 6 }}>
          Signed in as
        </div>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'white' }}>
          {user?.first_name} {user?.last_name}
        </div>
        <div style={{ display: 'inline-block', background: ROLE_COLORS[role] || 'var(--accent)', color: 'var(--navy)', fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 20, marginTop: 4 }}>
          {ROLE_LABELS[role] || role}
        </div>
      </div>

      <div style={{ height: 1, background: 'rgba(255,255,255,0.08)', margin: '8px 0' }} />

      <div className="sidebar-section">Overview</div>
      {item('/employee/dashboard', '📊', 'Dashboard')}
      {item('/employee/landlords', '🏢', 'Landlords')}
      {item('/employee/tenants', '👥', 'All Tenants')}

      {isOps && <>
        <div className="sidebar-section">Operations</div>
        {item('/employee/service', '📡', 'Service Control')}
        {item('/employee/documents', '📄', 'Documents')}
        {item('/employee/tickets', '🎫', 'Support Tickets')}
      </>}

      {isMarketing && <>
        <div className="sidebar-section">Marketing</div>
        {item('/employee/campaigns', '📧', 'Email Campaigns')}
        {item('/employee/payment-alerts', '⚠️', 'Payment Alerts')}
      </>}

      {isBilling && <>
        <div className="sidebar-section">Billing</div>
        {item('/employee/billing', '💰', 'Billing & Payouts')}
      </>}

      {isSuperAdmin && <>
        <div className="sidebar-section">Admin</div>
        {item('/employee/staff', '👤', 'Staff Management')}
        {item('/employee/plans', '📋', 'Service Plans')}
        {item('/employee/isps', '🔌', 'ISPs')}
        {item('/employee/marketing', '🖨️', 'Marketing Materials')}
        {item('/employee/bulk-import', '📥', 'Bulk Import')}
      </>}
    </nav>
  );
}
